import React from 'react';
import {Button, Stack, Typography} from '@mui/material';

export default function PublicPagination({pagina, paginare, onChange}) {
    if (!paginare || paginare.totalPagini <= 1) return null;
    return <Stack component="nav" aria-label="Paginare" direction="row" useFlexGap spacing={1} sx={{mt: 3, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center'}}>
        <Button variant="outlined" size="small" disabled={pagina <= 1} onClick={() => onChange(pagina - 1)}>← Anterior</Button>
        <Typography variant="body2" color="text.secondary">Pagina {paginare.pagina} din {paginare.totalPagini}</Typography>
        <Button variant="outlined" size="small" disabled={pagina >= paginare.totalPagini} onClick={() => onChange(pagina + 1)}>Următor →</Button>
    </Stack>;
}
